export const saveTokenWithExpiry = (token, expiryDays = 1) => {
    const now = new Date().getTime();
    const expiry = now + expiryDays * 24 * 60 * 60 * 1000;
    const tokenData = {
      value: token,
      expiry,
    };
    localStorage.setItem("access_token", JSON.stringify(tokenData));
  };
  
 
  export const getValidToken = () => {
    const item = localStorage.getItem("access_token");
    if (!item) return null;
  
    try {
      const { value, expiry } = JSON.parse(item);
      const now = new Date().getTime();
      if (now > expiry) {
        console.warn("Token expired, removing from storage.");
        localStorage.removeItem("access_token");
        return null;
      }
      return value;
    } catch (e) {
      console.error("Error parsing token from storage:", e);
      localStorage.removeItem("access_token");
      return null;
    }
  };